import type { NavigationItem } from '@/types'

export const mainNavigation: Array<NavigationItem> = [
    { label: "Windows", href: '/products#windows' },
    { label: "Doors", href: '/products#doors' },
    { label: "Conservatories", href: '/products#conservatories' },
    { label: "About", href: '/about' },
    { label: "Reviews", href: '/#reviews' },
    { label: "FAQ", href: '/#faq' }
]

export const footerNavigation: Array<{ title: string, links: Array<NavigationItem> }> = [
    {
        title: "Products",
        links: [
            { label: "All products", href: '/products' },
            { label: "Windows", href: '/products#windows' },
            { label: "Doors", href: '/products#doors' },
            { label: "Conservatories", href: '/products#conservatories' }
        ]
    },
    {
        title: "Company",
        links: [
            { label: "About us", href: '/about' },
            { label: "Customer reviews", href: '/#reviews' },
            { label: "How it works", href: '/#how-it-works' },
            { label: "FAQ", href: '/#faq' }
        ]
    }
]
